import type { RouteRecordRaw } from 'vue-router'

// Routes of the quiz-modes area. meta.account: requires a signed-in account.
export const routes: RouteRecordRaw[] = [
  { path: '/quiz/random', name: 'quiz-random', component: () => import('./RandomView.vue') },
  { path: '/quiz/exam', name: 'quiz-exam', component: () => import('./ExamView.vue') },
  { path: '/quiz/bookmarks', name: 'quiz-bookmarks', component: () => import('./BookmarksView.vue'), meta: { account: true } },
]
